<template>
  <div class="technology">
    <el-form :model="ruleForm" :rules="ruleFormRules" ref="ruleForm" label-width="200px" class="technology-ruleForm">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="12" :lg="11" :xl="9">
          <el-form-item :label="$t('crm.systemName')" prop="vendorSystemId">
            <el-select v-model="ruleForm.vendorSystemId" filterable :placeholder="$t('crm.selectSystem')">
              <el-option v-for="(item, index) in systemList" :key="index" :label="item.systemName" :value="item.vendorSystemId"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('crm.productConnectivityMethod')" prop="productSourceType">
            <el-radio-group v-model="ruleForm.productSourceType" @change="handleSourceTypeChange">
              <template v-for="(item, index) in productSourceType">
                <el-radio class="radio-list" :key="index" :label="item.dictCode">
                  {{ item.dictValue }}
                </el-radio>
              </template>
            </el-radio-group>
          </el-form-item>

          <el-form-item :label="$t('crm.stockConnectivityMethod')" prop="vendorStockType">
            <el-radio-group :disabled="ruleForm.productSourceType === '1'" v-model="ruleForm.vendorStockType">
              <template v-for="(item, index) in vendorStockTypeList">
                <el-radio v-if="!(vendorTypeId == 1 && item.dictCode == 2)" class="radio-list" :key="index"
                  :label="item.dictCode">
                  {{ item.dictValue }}
                </el-radio>
              </template>
            </el-radio-group>
          </el-form-item>

          <el-form-item :label="$t('crm.geography')" prop="spuSplitGroupId">
            <el-select disabled v-model="ruleForm.spuSplitGroupId"
              :placeholder="$t('crm.selectGeography')">
              <el-option v-for="(item, index) in businessRegionList" :key="index" :label="item.groupName"
                :value="item.spuSplitGroupId"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('crm.portfields')" prop="exportFields">
            <el-checkbox-group v-model="ruleForm.exportFields">
              <el-checkbox label="boutiqueId" name="type">Boutique ID</el-checkbox>
              <el-checkbox label="skuCode" name="type">barcode</el-checkbox>
              <!-- <el-checkbox v-for="(item,index) in exportFieldsList"  :key="index" label="美食/餐厅线上活动" name="type"></el-checkbox> -->
            </el-checkbox-group>
          </el-form-item>
          <el-form-item :label="$t('crm.orderFields')" prop="orderFields">
            <el-checkbox-group v-model="ruleForm.orderFields">
              <el-checkbox label="boutiqueOrderId" name="boutiqueOrderId">Boutique Order ID</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="订单页面显示字段" prop="orderShowFields">
            <el-checkbox-group v-model="ruleForm.orderShowFields">
              <el-checkbox label="boutiqueId" name="boutiqueId">boutiqueId</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item :label="$t('crm.stockValidPeriod')" prop="stockExpiry">
            <el-input-number :min="0" v-model="ruleForm.stockExpiry"></el-input-number>
          </el-form-item>

          <el-form-item :label="$t('crm.switchOfFullClared')" prop="fullStockClearFlagList">
            <el-checkbox-group v-model="ruleForm.fullStockClearFlagList">
              <el-checkbox :label="$t('crm.fullGoods')" name="type"></el-checkbox>
              <el-checkbox :label="$t('crm.fullStock')" name="type"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item :label="$t('crm.fullClearPercentage')" prop="zeroScale">
            <el-input v-model="ruleForm.zeroScale" @input="(val) => inputNum(val, 'zeroScale')" @change="(val) => changeNum(val, 'zeroScale')" style="width: 120px;">
              <i slot="suffix" class="el-input__icon">%</i>
            </el-input>
          </el-form-item>

          <el-form-item :label="$t('crm.skuCodeAskeyCode')" prop="skuCodeUnique">
            <el-radio-group v-model="ruleForm.skuCodeUnique">
              <el-radio :label="false">{{ $t('common.no') }}</el-radio>
              <el-radio :label="true">{{ $t('common.yes') }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item :label="$t('crm.orderNotifyEmail')" prop="orderNotificationUrl">
            <el-input v-model="ruleForm.orderNotificationUrl"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm.orderNotifyStatus')" prop="apiOrderStatusEnumList">
            <el-checkbox-group v-model="ruleForm.apiOrderStatusEnumList">
              <el-checkbox :key="index" v-for="(item, index) in apiOrderStatusEnumStatusList" :label="item"
                name="type"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item :label="$t('crm.isCo')" prop="coFlag">
            <el-radio-group v-model="ruleForm.coFlag">
              <el-radio :label="0">{{ $t('common.no') }}</el-radio>
              <el-radio :label="1">{{ $t('common.yes') }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item :label="$t('crm.officialWebsite')" prop="officialWebsiteUrl">
            <el-input v-model="ruleForm.officialWebsiteUrl"></el-input>
          </el-form-item>

          <el-form-item :label="$t('crm.supportAftersalesPriceReduction')" prop="afterSaleFlag">
            <el-radio-group v-model="ruleForm.afterSaleFlag" :disabled="loadedAfterSaleFlag">
              <el-radio :label="false">{{ $t('common.no') }}</el-radio>
              <el-radio :label="true">{{ $t('common.yes') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('crm.vendorStageRuleRow')" prop="vendorStageRuleRow" v-if="ruleForm.afterSaleFlag">
            <el-input-number :min="1" v-model="ruleForm.vendorStageRuleRow"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('crm.daysOfAftersalePriceReductionCycle')" v-if="ruleForm.afterSaleFlag" prop="days">
            <el-input-number :min="0" v-model="ruleForm.days"></el-input-number>
          </el-form-item>

          <template v-if="vendorId">
            <el-form-item :label="$t('crm.vendorGeography')" prop="addressCountryId">
              <el-select class="width220" v-model="ruleForm.addressCountryId" :placeholder="$t('crm.selectVendorGeography')">
                <el-option v-for="(item, index) in countryList" :key="index" :label="item.name"
                  :value="item.addressCountryId"></el-option>
              </el-select>
              <el-button @click="vendorConfigfinished('update_country')" v-if="configObj.update_country"
                style="margin-left:10px" size="small" type="primary">{{ $t('crm.processingComplete') }}</el-button>
            </el-form-item>
            <el-form-item :label="$t('crm.vendorCurrency')" prop="originalPriceUnit">
              <el-select class="width220" v-model="ruleForm.originalPriceUnit" :placeholder="$t('crm.selectVendorCurrency')">
                <el-option v-for="(item, index) in unitList" :key="index" :label="item.fromCountry"
                  :value="item.fromCountry"></el-option>
              </el-select>
              <el-button @click="vendorConfigfinished('update_currency')" v-if="configObj.update_currency"
                style="margin-left:10px" size="small" type="primary">{{ $t('crm.processingComplete') }}</el-button>
            </el-form-item>
            <el-form-item :label="$t('crm.retailPriceIncludesTax')" prop="retailPriceTax">
              <el-radio-group v-model="ruleForm.retailPriceTax">
                <el-radio :label="1">{{ $t('crm.taxIncluded') }}</el-radio>
                <el-radio :label="2">{{ $t('crm.taxExcluded') }}</el-radio>
              </el-radio-group>
              <el-button @click="vendorConfigfinished('update_retail_price_tax')" v-if="configObj.update_retail_price_tax"
                style="margin-left:10px" size="small" type="primary">{{ $t('crm.processingComplete') }}</el-button>
            </el-form-item>
            <el-form-item :label="$t('crm.pricingConnectivityMethod')" prop="vendorSupplyPriceMethod">
              <el-radio-group v-model="ruleForm.vendorSupplyPriceMethod" @change="onChangeVendorSupplyPriceMethod">
                <el-radio v-for="(item, index) in supplyPriceMethodList" :key="index"
                  :label="item.dictCode">{{ item.dictValue }}</el-radio>
              </el-radio-group>
              <el-button @click="vendorConfigfinished('update_supply_method')" v-if="configObj.update_supply_method"
                style="margin-left:10px" size="small" type="primary">{{ $t('crm.processingComplete') }}</el-button>
            </el-form-item>
            <el-form-item v-if="ruleForm.vendorSupplyPriceMethod == '1'" :label="$t('crm.supplyPriceIncludesTax')"
              prop="boutiquePriceTax">
              <el-radio-group v-model="ruleForm.boutiquePriceTax">
                <el-radio :label="1">{{ $t('crm.taxIncluded') }}</el-radio>
                <el-radio :label="2">{{ $t('crm.taxExcluded') }}</el-radio>
              </el-radio-group>
              <el-button @click="vendorConfigfinished('update_supply_price_tax')" v-if="configObj.update_supply_price_tax"
                style="margin-left:10px" size="small" type="primary">{{ $t('crm.processingComplete') }}</el-button>
            </el-form-item>
            <el-form-item v-if="ruleForm.vendorSupplyPriceMethod == '2'" :label="$t('crm.provideRetailPrice')"
              prop="provideRetailPrice">
              <el-radio-group v-model="ruleForm.provideRetailPrice">
                <el-radio :label="1">{{ $t('common.yes') }}</el-radio>
                <el-radio :label="2">{{ $t('common.no') }}</el-radio>
              </el-radio-group>
              <el-button @click="vendorConfigfinished('update_provide_retail_price')"
                v-if="configObj.update_provide_retail_price" style="margin-left:10px" size="small"
                type="primary">{{ $t('crm.processingComplete') }}</el-button>
            </el-form-item>
            <el-form-item
              v-if="ruleForm.vendorSupplyPriceMethod == '1' && (ruleForm.productSourceType == '2' || ruleForm.productSourceType == '4')"
              :label="$t('crm.portalPriceAdjustment')" prop="isBatchImportUpdatePrice">
              <el-radio-group v-model="ruleForm.isBatchImportUpdatePrice">
                <el-radio :label="true">{{ $t('common.yes') }}</el-radio>
                <el-radio :label="false">{{ $t('common.no') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('crm.technicalContact')" prop="technicalContact">
              <div class="mb20">
                <el-input v-model="inputTechnicalContact" style="width: 200px; margin-right: 10px" size="medium"
                  placeholder="技术联系人"></el-input>
                <el-button type="primary" icon="el-icon-plus" size="medium" :disabled="!inputTechnicalContact"
                  @click="addTechnicalContact" circle></el-button>
              </div>
              <div class="email-item" v-for="(item, index) in ruleForm.technicalContact" :key="item + index">{{ item }}
                <i @click="onClickRemove(index)" class="icon-close el-icon-circle-close"></i>
              </div>
            </el-form-item>
          </template>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="11" :xl="9">
          <p class="group-title" v-if="vendorTypeId == '3'">{{ $t('crm.wholesaleV2Conf') }}</p>
          <el-form-item v-if="vendorTypeId == '3'" :label="$t('crm.wholesaleField1')" prop="wholesaleOneVendorId">
            <el-select v-model="ruleForm.wholesaleOneVendorId" filterable>
              <el-option v-for="item in xiajiArr" :label="item.vendorName" :value="item.vendorId" :key="item.vendorId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="vendorTypeId == '3'" :label="$t('crm.wholesaleField2')" prop="marketplaceVendorId">
            <el-select v-model="ruleForm.marketplaceVendorId" filterable>
              <el-option v-for="item in tongbuArr" :label="item.vendorName" :value="item.vendorId" :key="item.vendorId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-form-item v-if="ruleForm.vendorSupplyPriceMethod == '1' || supplyPriceMethod === 'boutique price'" :label="$t('crm.allowCategoryMappingFail')" prop="isAllowNoCategory">
          <el-switch v-model="ruleForm.isAllowNoCategory"></el-switch>
        </el-form-item> -->
    </el-form>
    <div class="submitBtn">
      <el-button @click="submitForm" size="medium" type="primary">{{ $t('crm.submit') }}</el-button>
      <el-button @click="goBack" style="margin-left:10px" size="medium">{{ $t('crm.cancel') }}</el-button>
    </div>
  </div>
</template>


<script>
import { getSystemList, vendorAreaListLevelOne, getCountryList, getUnitList, getDictEnumList, prepareItConfiguration, updateItConfiguration, getConfigChange, vendorConfigfinished, getItConfigurationDetail } from './api';
import {
  getXiaJiTongBuList,
} from '../buyershop/api'

export default {
  data() {
    return {
      loadedAfterSaleFlag: false,
      ruleForm: {
        apiOrderStatusEnumList: [],//订单通知状态列表
        orderNotificationUrl: "",//订单通知链接
        officialWebsiteUrl: '',
        afterSaleFlag: false,
        days: 0,
        zeroScale: null, //全量清零比例
        skuCodeUnique: false,//接入skucode码
        coFlag: 0,//是否CO
        fullStockClearFlagList: ['商品全量', '库存全量'],//全量清零开关列表
        stockExpiry: "",//库存有效期
        exportFields: [],//导入/导出字段
        orderFields: [],
        orderShowFields: [],
        spuSplitGroupId: "", //业务区域
        vendorSystemId: "",//系统ID
        vendorStockType: "",//库存接入方式
        addressCountryId: "",//买手店所在国家
        originalPriceUnit: "",//店铺币种
        retailPriceTax: "",//吊牌价是否含税
        vendorSupplyPriceMethod: "",//价格接入方式
        boutiquePriceTax: "",//供货价是否含税
        provideRetailPrice: "",//是否提供吊牌价
        productSourceType: '',
        isAllowNoCategory: null,//是否允许类目mapping失败
        isBatchImportUpdatePrice: false,
        technicalContact: [],
        wholesaleOneVendorId: null,
        marketplaceVendorId: null,
        vendorStageRuleRow: null
      },
      ruleFormRules: {
        vendorSystemId: [
          { required: true, message: `${this.$t('crm.selectSystemName')}`, trigger: 'change' }
        ],
        vendorStockType: [
          { required: true, message: `${this.$t('crm.selectVendorStockType')}`, trigger: 'change' }
        ],
        productSourceType: [
          { required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.productConnectivityMethod')}`, trigger: 'change' }
        ],
        wholesaleOneVendorId: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.wholesaleField1')}` }],
        marketplaceVendorId: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.wholesaleField2')}` }],
        vendorStageRuleRow: [
          { required: true, message: `${this.$t('common.plzInput')}${this.$t('crm.vendorStageRuleRow')}`, trigger: 'blur' }
        ],
      },
      systemList: [], //系统名称列表
      vendorStockTypeList: [],//库存接入方式列表
      businessRegionList: [],//业务区域列表
      apiOrderStatusEnumStatusList: ['Pending', 'Confirmed', 'Shipped', 'Delivered', 'Finished', 'Cancelled'],
      countryList: [],//国家列表
      unitList: [],//币种列表
      supplyPriceMethodList: [],//价格接入方式
      vendorId: '',
      crmPrepareVendorId: "",
      configObj: { //配置信息

      },
      configChangeList: [],
      vendorTypeId: '', //店铺类型
      productSourceTypeId: '', //商品接入方式
      productSourceType: [],
      supplyPriceMethod: null, // 供货价方式
      inputTechnicalContact: '',
      tongbuArr: [],
      xiajiArr: [],
    }
  },
  watch: {
    '$i18n.locale'(newValue) { //监听i18n中英文
      // console.error(newValue,'vvvv')
      if (newValue) {
        this.getDictEnumListStock();
        this.getDictEnumListPrice()
      }
    }
  },
  methods: {
    onChangeVendorSupplyPriceMethod(val) {
      if (val != '1') {
        this.ruleForm.isBatchImportUpdatePrice = false;
      }
    },
    vendorConfigfinished(code) {
      let configChangeList = this.configChangeList;
      console.error(configChangeList, code, 'configChangeList')
      let id = (configChangeList.find(item => item.code == code) || {}).id;
      vendorConfigfinished({ id }).then(res => {
        console.error(res, 'rrrrr')
        if (res.data && res.data.success) {
          this.$message.success('处理成功')
          this.getConfigChange(this.vendorId)
        }
      })
    },
    submitForm() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {

          let { fullStockClearFlagList, addressCountryId, originalPriceUnit, retailPriceTax, vendorSupplyPriceMethod, boutiquePriceTax, exportFields, orderFields, orderShowFields, systemName, vendorStageRuleRow, ...reset } = this.ruleForm
          console.error(this.ruleForm, fullStockClearFlagList, this.$route.query)
          let { crmPrepareVendorId, vendorId } = this.$route.query;
          let productFullStockClearFlag = false, stockFullStockClearFlag = false;
          if (fullStockClearFlagList.includes('商品全量') || fullStockClearFlagList.includes('goods')) {
            productFullStockClearFlag = true
          }
          if (fullStockClearFlagList.includes('库存全量') || fullStockClearFlagList.includes('stock')) {
            stockFullStockClearFlag = true;
          }
          exportFields = exportFields.join(',')
          orderFields = orderFields.join(',')
          if (!this.vendorId) { //创建中店铺
            prepareItConfiguration({
              crmPrepareVendorId,
              productFullStockClearFlag,
              stockFullStockClearFlag,
              exportFields,
              orderFields,
              vendorStageRuleRow,
              ...reset,
            }).then(res => {
              console.error(res, 'rrrr')
              if (res.data && res.data.success) {
                this.$message.success('操作成功')
                setTimeout(() => {
                  this.$router.push({
                    path: '/crm/list'
                  })
                }, 1000)
              } else {
                let { message } = res.data
                this.$message.error(`${message}`)
              }
            })
          } else { //已创建店铺
            updateItConfiguration({
              vendorId,
              productFullStockClearFlag,
              stockFullStockClearFlag,
              exportFields,
              orderFields,
              orderShowFields: orderShowFields && orderShowFields.length ? orderShowFields[0] : "",
              ...reset,
              addressCountryId,//买手店所在国家
              originalPriceUnit,//店铺币种
              retailPriceTax,//吊牌价是否含税
              vendorSupplyPriceMethod,//价格接入方式
              boutiquePriceTax,//供货价是否含税
              vendorStageRuleRow
            }).then(res => {
              console.error(res, 'update')
              if (res.data && res.data.success) {
                this.$message.success('操作成功')
                setTimeout(() => {
                  this.$router.push({
                    path: '/crm/list'
                  })
                }, 1000)
              } else {
                this.$message.error(res.data.message)
              }
            })
          }




        } else {
          console.log('error submit!!');
          return false;
        }
      });





    },
    goBack() {
      if (this.$route.query.crmPrepareVendorId) {
        this.$router.back();
      } else {
        window.close();
      }
    },
    getDictEnumListStock() {
      return new Promise((resolve) => {
        getDictEnumList({
          parentCode: 'stock_cut_type', //库存接入方式
        }).then(res => {
          if (res && res.code == '200') {
            this.vendorStockTypeList = res.data || []
            resolve(true)
          }
        })
      })
    },
    getDictEnumListPrice() {
      return new Promise((resolve) => {
        getDictEnumList({
          parentCode: 'supply_price_method',//价格接入方式
        }).then(res => {
          console.error(res, 'supply_price_method')
          if (res && res.code == '200') {
            this.supplyPriceMethodList = res.data || []
            resolve(true)
          }
        })
      })
    },
    getProductSourceType() {
      return getDictEnumList({
        parentCode: 'product_source_type',
      }).then(res => {
        if (res.success && res.data) {
          this.productSourceType = res.data || [];
        }
      });
    },
    getSystemList() {
      return new Promise((resolve) => {
        getSystemList().then(res => { //系统名称列表
          if (res && res.code == '200') {
            this.systemList = res.data || []
            resolve(true)
          }
        })
      })
    },
    vendorAreaListLevelOne() {
      return new Promise((resolve) => {
        vendorAreaListLevelOne().then(res => { //区域列表
          console.error(res, 'vendorAreaListLevelOne')
          if (res && res.code == '200') {
            this.businessRegionList = (res.data || []).filter(item => item.spuSplitGroupId != 1);
            resolve(true)
          }
        })
      })
    },
    getCountryList() {
      return new Promise((resolve) => {
        getCountryList().then(res => { //国家列表
          console.error(res, 'getCountryList')
          this.countryList = res.data || []
          resolve(true)
        })
      })
    },
    getUnitList() {
      return new Promise((resolve) => {
        getUnitList().then(res => { //币种
          console.error(res, 'rrrr3333')
          if (res && res.code == '200') {
            this.unitList = res.data || []
            resolve(true)
          }
        })
      })
    },
    getConfigChange(vendorId) {
      getConfigChange({ vendorId }).then(res => { //买手店信息
        // console.error(res,'getconfigchage')
        if (res && res.code == '200') {
          let configChangeList = res.data || []
          let configObj = {}
          configChangeList.forEach(item => {
            configObj[item.code] = true;
          })
          this.configChangeList = configChangeList;
          this.configObj = configObj;
          console.error(configObj, 'configObj')
        }

      })
    },
    handleSourceTypeChange(val) { //商品接入方式切换
      if (val === '1') {
        this.ruleForm.vendorStockType = "1"
      } else {
        this.ruleForm.isBatchImportUpdatePrice = null;
        // this.ruleForm.vendorStockType = ""
      }
    },
    addTechnicalContact() {
      this.ruleForm.technicalContact.push(this.inputTechnicalContact);
      this.inputTechnicalContact = null;
    },
    onClickRemove(i) {
      this.ruleForm.technicalContact.splice(i, 1);
    },
    inputNum(val, field) {
      val = val.replace(/[^\d]/g, '');
      if (val > 100) {
        val = 100;
      }
      this.ruleForm[field] = val;
    },
    changeNum(val, field) {
      if (val && val < 50) {
        this.ruleForm[field] = 50;
      }
    },

  },
  mounted() {
    console.error(this.$i18n, 'innn')

    Promise.all([this.getDictEnumListStock(), this.getDictEnumListPrice(), this.getProductSourceType(), this.getSystemList(), this.vendorAreaListLevelOne(), this.getCountryList(), this.getUnitList()]).then(res => {
      console.error(res, 'promiseAll')

      if (this.$route.query.vendorId) { //已创建
        let vendorId = this.$route.query.vendorId
        this.vendorId = vendorId
        let { vendorTypeId, productSourceTypeId } = this.$route.query;
        this.vendorTypeId = vendorTypeId;
        this.productSourceTypeId = productSourceTypeId;
        this.getConfigChange(vendorId)
        getItConfigurationDetail({ vendorId }).then(res => {
          console.error(res, 'getItConfigurationDetail')
          if (res && res.code == '200') {
            let { crmPrepareVendorId, productFullStockClearFlag, stockFullStockClearFlag, apiOrderStatusEnumList, productSourceType, vendorStockType, vendorSupplyPriceMethod, exportFields, orderFields, orderShowFields, spuSplitGroupName, isBatchImportUpdatePrice, technicalContact, ...reset } = res.data;
            apiOrderStatusEnumList = apiOrderStatusEnumList ? apiOrderStatusEnumList : [];
            exportFields = exportFields ? exportFields.split(',') : [];
            orderFields = orderFields ? orderFields.split(',') : [];
            orderShowFields = orderShowFields ? orderShowFields.split(',') : [];

            let fullStockClearFlagList = []
            if (productFullStockClearFlag) {
              fullStockClearFlagList.push('商品全量')
            }
            if (stockFullStockClearFlag) {
              fullStockClearFlagList.push('库存全量')
            }

            this.ruleForm = {
              ...reset,
              exportFields,
              orderFields,
              orderShowFields,
              fullStockClearFlagList,
              apiOrderStatusEnumList,
              vendorStockType: String(vendorStockType),
              productSourceType: String(productSourceType),
              vendorSupplyPriceMethod: String(vendorSupplyPriceMethod),
              spuSplitGroupId: (this.businessRegionList.find(item => item.groupName == spuSplitGroupName) || {}).spuSplitGroupId,
              // addressCountryId:String(addressCountryId)
              isBatchImportUpdatePrice,
              technicalContact: technicalContact || [],
            }
            this.loadedAfterSaleFlag = this.ruleForm.afterSaleFlag;

            this.ruleForm.coFlag = this.ruleForm.coFlag || 0;
            console.error(this.ruleForm, 'ruleFomr')
          }
        })
      }
      if (this.$route.query.crmPrepareVendorId) { //创建中
        this.crmPrepareVendorId = this.$route.query.crmPrepareVendorId
        let { addressCountryName, vendorTypeId, productSourceTypeId,wholesaleOneVendorId,marketplaceVendorId } = this.$route.query;
        this.ruleForm.wholesaleOneVendorId = wholesaleOneVendorId ? Number(wholesaleOneVendorId) : null;
        this.ruleForm.marketplaceVendorId = marketplaceVendorId ? Number(marketplaceVendorId) : null;
        this.vendorTypeId = vendorTypeId;
        // console.error(vendorTypeId,productSourceTypeId,this.vendorStockTypeList,'vendorTypeId,productSourceTypeId')
        //全量清零开关默认全选
        if (this.$i18n.locale == 'zh-CN') {
          this.ruleForm.fullStockClearFlagList = ['商品全量', '库存全量']
        } else {
          this.ruleForm.fullStockClearFlagList = ['Full goods quantity connection', 'Full stock quantity connection']
        }
        // if(['中国香港','中国澳门'].includes(addressCountryName)){
        //   this.ruleForm.spuSplitGroupId = 1
        // }else
        if (addressCountryName == '中国') {
          this.ruleForm.spuSplitGroupId = 3
        } else {
          this.ruleForm.spuSplitGroupId = 2
        }
        this.supplyPriceMethod = this.$route.query.supplyPriceMethod;
        this.ruleForm.zeroScale = 100;
      }


    })

    getXiaJiTongBuList({ vendorType: 0 }).then(res => {
      if (res.success && res.data) {
        this.tongbuArr = res.data;
      }
    });
    getXiaJiTongBuList({ vendorType: 1 }).then(res => {
      if (res.success && res.data) {
        this.xiajiArr = res.data;
      }
    });

  }
}


</script>


<style lang="less" scoped>
.technology {
  position: relative;
  padding: 20px 20px 100px 20px;

  .width220 {
    width: 220px
  }
}

.radio-list {
  display: block;
  line-height: 25px;
}

.email-item {
  position: relative;
  display: inline-block;
  padding: 0 30px 0 10px;
  margin: 0 15px 15px 0;
  line-height: 30px;
  border: 1px solid #ccc;
  border-radius: 30px;

  .icon-close {
    position: absolute;
    top: 0;
    right: 0;
    width: 30px;
    height: 30px;
    font-size: 16px;
    text-align: center;
    line-height: 30px;
    cursor: pointer;

    &:hover {
      color: #409EFF;
    }
  }
}
.group-title {
  margin-left: 20px;
  margin-bottom: 10px;
  font-size: 14px;
}
</style>
